const SAFE_BASE_URL = "https://internal.invalid";
const UNSAFE_PATH_ESCAPE = /%(?:0[0-9a-f]|1[0-9a-f]|2f|5c|7f)/i;

// Redirect destinations may come from links and hidden form fields, so validate
// them at every server and browser navigation seam. Return a normalized local
// path; schemes, network paths, backslashes and encoded path separators fall
// back to the caller's known-safe destination.
export function safeRedirect(destination, fallback = "/") {
  if (typeof destination !== "string" || !destination.startsWith("/")) {
    return fallback;
  }
  if (
    destination.startsWith("//") ||
    destination.includes("\\") ||
    /[\u0000-\u001f\u007f]/.test(destination)
  ) {
    return fallback;
  }

  const path = destination.split(/[?#]/, 1)[0];
  if (UNSAFE_PATH_ESCAPE.test(path)) return fallback;

  try {
    const url = new URL(destination, SAFE_BASE_URL);
    if (url.origin !== SAFE_BASE_URL) return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}
